export default __webpack_public_path__ + "static/anuPrasad2-2a21343007499745441ccde1cb99053a.jpg";